import { gql } from '@apollo/client';
import client from '../apollo.';

export const createFurnitureLeaseMutation = async (createFurnitureLeaseInput) => {
  const { data, errors } = await client.mutate({
    mutation: gql`
      mutation CreateLeaseCustomerWithFurniture(
        $createFurnitureLeaseInput: CreateLeaseCustomerWithFurnitureDto!
      ) {
        createFurnitureLease(createFurnitureLeaseInput: $createFurnitureLeaseInput) {
          id
          entity {
            id
            name
          }
          attachments
        }
      }
    `,
    variables: {
      createFurnitureLeaseInput,
    },
  });
  return { data, errors };
};

export const fetchAllFurnitureLeaseQuery = async (entityId) => {
  const { data, errors } = await client.query({
    query: gql`
      query findAllfurnitureLease($entityId: Float!) {
        findAllFurnitureLease(entityId: $entityId) {
          id
          leaseNo
          address
          mailingAddress
          isReported
          startDate
          endDate
          totalValue
          premium
          entityId
          images
          attachments
          furnitureType
          customer {
            firstName
            lastName
            email
            phoneNumber
          }
        }
      }
    `,
    variables: {
      entityId,
    },
  });
  return { data, errors };
};

export const generateLeasePDFQuery = async (id) => {
  const { data, errors } = await client.query({
    query: gql`
      query FurnitureLeaseInvoice($id: Int!) {
        FurnitureLeaseInvoice(id: $id) {
          url
        }
      }
      `,
    variables: {
      id,
    },
  });
  return { data, errors };
};